import { BasicoApi } from '@common/api';

const AjudaService = {
  async getFoldersMain() {
    return await BasicoApi.get()(`/Ajuda`);
  },

  async getDocumentsList(folderName) {
    const res = await BasicoApi.get()(`/Ajuda/${folderName}`);
    return res.data || {};
  },

  async getCalibrationFiles(calibrationId = null) {
    const res = await BasicoApi.get()(`/Ajuda/calibracao/${calibrationId}`);
    return res.data?.length ? res.data[0] : {};
  },

  async getListFiles(param) {
    const data = await BasicoApi.get()(`/Ajuda/${param}`);
    return data;
  },

  async downloadFile(nameFile, folder) {
    return BasicoApi.post()(`/Ajuda/download`, {
      caminhoArquivo: folder,
      nomeArquivo: nameFile,
    });
  },
};

export default AjudaService;
